import { Col, Form, Input, Modal, Row, Upload } from 'antd';
import React, { useEffect, useRef } from 'react';
import RichTextEditor from './RTE/RichTextEditor';

const EmailModal = ({ title, open, close, onOk, options, defaultBodyFormat }) => {
    const [form] = Form.useForm();
    const editorRef = useRef(null);

    const dummyRequest = ({ fileList, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    const onSend = () => {
        const emailData = form.getFieldsValue();
        emailData.body = editorRef.current.getContent();
        onOk(emailData);
    }

    useEffect(() => {
        if (options)
            form.setFieldsValue(options);
    }, [options]);

    return (
        <Modal
            open={open}
            onCancel={close}
            width={750}
            title={title ? title : "Send Email"}
            okText="Send"
            onOk={onSend}
        >
            <Form form={form} layout='vertical'>
                <Row>
                    <Col span={24}>
                        <Form.Item name="to">
                            <Input placeholder='To' />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name="cc">
                            <Input placeholder='CC' />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name="bcc">
                            <Input placeholder='BCC' />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name="subject">
                            <Input placeholder='Subject' />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name="body">
                            <RichTextEditor editorRef={editorRef} visible={true} height={300} initialValue={defaultBodyFormat}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            name="email-attachments"
                        >
                            <Upload.Dragger
                                customRequest={dummyRequest}
                                beforeUpload={() => false}
                                multiple={true}
                            >
                                <p className="ant-upload-drag-icon">
                                    {/* <InboxOutlined /> */}
                                </p>
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Upload.Dragger>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export default EmailModal;